import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import { Modal } from 'framework/ui/ui-builder';
import IosShareIcon from '@mui/icons-material/IosShare';
import { CopyToClipboardButton } from 'framework/ui/clipboard';
import { Box, Typography } from '@mui/material';
import { useShowContext } from 'framework/show';
import { SYCOM_UI_URL } from 'domain/recruiting/extension/candidateFromExtensionService';
import { FormFieldsData, TextInput } from 'framework/form';
import { Tooltip } from 'framework/ui/mui-builder';

const DirectLinkForSycomForm = () => {
  const { data: showData } = useShowContext();
  const { alias, technology, specialization } = showData.getData();

  const [title, setTitle] = useState<string>(`${specialization} ${technology ? `(${technology})` : ''}`);
  const [applyVacancyLink, setApplyVacancyLink] = useState<string>();

  useEffect(() => {
    if (title && alias) {
      setApplyVacancyLink(
        `${SYCOM_UI_URL}/careers/direct/?vacancyId=${alias}&vacancyTitle=${encodeURIComponent(title)}`,
      );
    } else {
      setApplyVacancyLink('');
    }
  }, [title, alias]);

  const onSourceNameChangeCallback = (values: FormFieldsData) => {
    setTitle(values.title);
  };

  return (
    <>
      <Box sx={{ marginTop: '10px' }}>
        <TextInput
          source="title"
          placeholder="Title"
          label=""
          onChangeCallback={onSourceNameChangeCallback}
          value={title}
        />

        <Box
          sx={{
            minHeight: '80px',
            width: '100%',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '10px',
            border: '1px solid',
            borderColor: 'border.default',
            borderRadius: '4px',
            overflow: 'hidden',
          }}
        >
          {applyVacancyLink ? (
            [
              <Box key="copyButton" sx={{ position: 'absolute', right: '5px', top: '5px' }}>
                <CopyToClipboardButton
                  id="copyApplyVacancyLink"
                  value={applyVacancyLink}
                  isContentCopyIcon
                  sx={{ color: 'primary.main' }}
                  isCopyingFromModal
                >
                  Copy the link
                </CopyToClipboardButton>
              </Box>,
              <Box key="copyText" sx={{ display: 'flex', alignItems: 'center', padding: '20px' }}>
                <CopyToClipboardButton
                  id="copyApplyVacancyLink"
                  value={applyVacancyLink}
                  isIcon={false}
                  sx={{ border: '0px', color: 'primary.main' }}
                  isCopyingFromModal
                >
                  {applyVacancyLink}
                </CopyToClipboardButton>
              </Box>,
            ]
          ) : (
            <Typography color="textSecondary" variant="body1">
              The link will be generated after selecting the vacancy and sourcing type
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

const DirectLinkForSycomButton = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Tooltip title="Direct link">
        <div>
          <IconButton
            onClick={(e: React.MouseEvent<HTMLElement>) => {
              setModalOpen(true);
              (e.target as HTMLElement).blur();
            }}
          >
            <IosShareIcon color="primary" fontSize="medium" />
          </IconButton>
        </div>
      </Tooltip>
      <Modal backdrop="static" isOpen={modalOpen} title="Direct link" onToggle={closeModal}>
        <DirectLinkForSycomForm />
      </Modal>
    </>
  );
};

export default DirectLinkForSycomButton;
